import { useState } from 'react'
import { Alert } from 'reactstrap'
import Spinner from '../Spinner/Spinner'
import { isDisabled, fetchBlob, getTenant, publishEvent, removeFileNamePrefix } from '../../utils'
import FileClearButton from '../FileClearButton/FileClearButton'
import FileChooseButton from '../FileChooseButton/FileChooseButton'
import FileInput from '../FileInput/FileInput'

export default function AppObjectFieldImage({ objectId, field, action, value, formInputs, handleChange, hasChanged }) {
  console.log(`AppObjectFieldImage rendered: ${field.name} value: ${value}`)

  const [imageInfo, setImageInfo] = useState()
  const disabled = isDisabled(action, field.behaviorType)

  function handleImageChange(event) {
    console.log('*********************************** AppObjectImage.handleImageChange')
    const eventData = {
      objectId: objectId,
      fieldId: field.id,
      file: event.target.files[0],
      formInputs: formInputs,
    }
    publishEvent(`FILE SELECTED ${objectId}`, eventData, 'AppObjectFieldImage')
    let fileName = removeFileNamePrefix(event.target.value, '\\')
    handleChange(fileName, hasChanged, field.id)
    const newImageInfo = {
      blobUrl: null,
      errorText: null,
    }
    if (event.target.files && event.target.files.length > 0) {
      newImageInfo.blobUrl = URL.createObjectURL(event.target.files[0])
    }
    setImageInfo(newImageInfo)
  }

  function handleFetchSuccess(blobUrl) {
    setImageInfo({
      blobUrl: blobUrl,
      errorText: null,
    })
  }

  function handleFetchError(errorText) {
    console.log('AppObjectImage.handleFetchError')
    console.log(errorText)
    setImageInfo({
      blobUrl: null,
      errorText: errorText,
    })
  }

  if (!imageInfo && value) {
    const tenant = getTenant()
    const url = `${process.env.REACT_APP_SERVER}/file/${tenant}/${value}`
    fetchBlob(url, handleFetchSuccess, handleFetchError)
    return <Spinner className="app-object-field-image-spinner" />
  }

  if (imageInfo && imageInfo.errorText) {
    return <Alert className="app-object-alert" color="danger">{imageInfo.errorText}</Alert>
  }

  let imageLink = null
  let clearButton = null
  if (imageInfo && imageInfo.blobUrl) {
    imageLink =
      <a href={imageInfo.blobUrl} target="_blank" rel="noopener noreferrer">
        <img className="app-object-field-image-img" src={imageInfo.blobUrl} alt={field.name} />
      </a>
    clearButton = <FileClearButton handleInputChange={handleImageChange} />
  }

  if (disabled) {
    return imageLink
  } else {
    return (
      <div>
        {imageLink}
        <FileInput fieldId={field.id} handleChange={handleImageChange} accept={'image/*'} />
        <div className="app-object-field-file-button-container">
          <FileChooseButton fieldId={field.id} buttonText={'Choose Image File'} />
          {clearButton}
        </div>
      </div>
    )
  }
}
